var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.825 15 13.5315 14.7065 14.1195 14.1195C14.7075 13.5325 15.001 12.826 15 12C14.999 11.174 14.7055 10.468 14.1195 9.882C13.5335 9.296 12.827 9.002 12 9C11.173 8.998 10.467 9.292 9.882 9.882C9.297 10.472 9.003 11.178 9 12C8.997 12.822 9.291 13.5285 9.882 14.1195C10.473 14.7105 11.179 15.004 12 15ZM12 30C7.975 26.575 4.969 23.394 2.982 20.457C0.995 17.52 0.001 14.801 0 12.3C0 8.55 1.2065 5.5625 3.6195 3.3375C6.0325 1.1125 8.826 0 12 0C15.174 0 17.968 1.1125 20.382 3.3375C22.796 5.5625 24.002 8.55 24 12.3C24 14.8 23.0065 17.519 21.0195 20.457C19.0325 23.395 16.026 26.576 12 30Z",
    fill: "#102B41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationIcon);
export default __webpack_public_path__ + "static/media/destinationIcon.523be1bebc6d90c82591e47414ce7f57.svg";
export { ForwardRef as ReactComponent };